var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Заказ #"+_vm._s(_vm.id))]),_c('list',{attrs:{"itemLink":_vm.itemLink,"columns":_vm.columns,"disable_add":true,"params":_vm.params,"searchDisable":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }